<template>
  <div class="t-content">
    <!-- <a-button class="app-btn info-btn mb-5" @click="add">添加新资料</a-button> -->
    <!-- <a-button class="app-btn info-btn mb-5 ml-5" @click="addFromModal">从模版库添加</a-button> -->
    <!-- <a-button v-if="documentList && documentList.length > 0" class="app-btn info-btn mb-5 ml-5" @click="updateSort">
      修改排序
    </a-button> -->
    <!-- <a-button
      v-if="(!productTypeList || productTypeList.length === 0) && (!documentList || documentList.length === 0)"
      class="app-btn info-btn mb-5 ml-5"
      @click="copyModal"
    >
      复制
    </a-button> -->
    <!-- <a-button class="app-btn info-btn mb-5" style="float: right" @click="addData">添加身份类型</a-button> -->

    <div class="p-m-table">
      <div ref="systemForm" class="hadder" @scroll="sysHandleScroll()">
        <div class="h-t" style="width: 200px; border-right: 1px solid #dfdfdf; position: sticky; top: 0; left: 0">
          资料名称
        </div>
        <div
          v-for="(item, index) in productTypeList"
          :key="index"
          class="h-t"
          style="width: 200px; border-right: 1px solid #dfdfdf; padding: 0 10px; display: flex"
        >
          <div style="width: 140px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
            {{ item.occupationName }}
          </div>
          <a-icon
            type="edit"
            style="float: right; line-height: 55px; cursor: pointer; color: #fff; margin-right: 5px"
            theme="twoTone"
            @click="editType(index, item)"
          />
          <app-icon
            type="icon-shanchu"
            style="float: right; line-height: 55px; cursor: pointer; color: #fff"
            @click="removeType(index, item.occupationId)"
          ></app-icon>
        </div>
      </div>
      <div style="display: flex">
        <div
          ref="externalForm1"
          class="p-m-title m-tt"
          style="width: 200px; padding-bottom: 10px"
          @scroll="synchronousScroll"
        >
          <div
            v-for="(item, index) in documentList"
            :key="index"
            class="content"
            style="border-right: 1px solid #dfdfdf"
            :style="{ background: index % 2 ? '#f8f8f8' : '' }"
          >
            <div class="h-c" style="width: 200px">
              <div class="h-c-d" style="width: 65%">
                <div style="display: flex; flex-direction: column">
                  <div style="text-align: center">{{ item.documentName }}</div>
                  <div style="text-align: center">
                    <span style="margin-right: 20px; color: #df7163; cursor: pointer" @click="editData(item, index)">
                      编辑
                    </span>
                    <span style="color: #df7163; cursor: pointer" @click="removeData(index)">删除</span>
                  </div>
                </div>
              </div>
              <div class="h-c-d" style="width: 35%; flex: 1; display: flex; flex-direction: column">
                <div class="h-c-item">需要：</div>
                <div class="h-c-item">必填：</div>
                <div class="h-c-item">分类：</div>
              </div>
            </div>
          </div>
        </div>

        <div ref="externalForm" style="flex: 1" class="p-m-title" @scroll="exterHandleScroll()">
          <div
            v-for="(item, index) in documentList"
            :key="index"
            class="content"
            style="border-left: 1px solid #dfdfdf"
            :style="{ background: index % 2 ? '#f8f8f8' : '' }"
          >
            <div class="h-c-1">
              <div
                v-for="(c, ic) in item.children"
                :key="ic"
                class="h-c-1-s"
                :style="{ background: index % 2 ? '#f8f8f8' : '' }"
              >
                <div>
                  <div class="l-input">
                    <a-select v-model="c.isNeed" @change="selectIsNeed(item, c, ic)" placeholder="请选择类型">
                      <a-select-option :value="1">需要</a-select-option>
                      <a-select-option :value="0">不需要</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div v-if="c.isNeed">
                  <div class="l-input">
                    <a-select v-model="c.required" placeholder="请选择类型">
                      <a-select-option :value="true">必填</a-select-option>
                      <a-select-option :value="false">非必填</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div v-if="c.isNeed">
                  <div class="l-input">
                    <a-select v-model="c.documentType" placeholder="请选择">
                      <a-select-option :value="1">电子资料</a-select-option>
                      <a-select-option :value="2">纸质资料</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
      <div class="detailView">
        <a-form class="form" :form="modal.form" :colon="false" layout="inline">
          <a-form-item label="资料类型" required>
            <a-input
              v-decorator="['occupationName', { rules: [{ required: true, message: '请输入资料类型' }] }]"
              placeholder="请输入资料类型"
            ></a-input>
          </a-form-item>
          <a-form-item label="排序值">
            <a-input
              v-decorator="['documentSort', { rules: [{ required: true, message: '请输入排序值' }] }]"
              placeholder="数字从小到大排序"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
    </a-modal> -->
    <!-- <a-modal :title="modal1.title" v-model="modal1.visible" @cancel="handleCancel" :width="800">
      <div class="detailView">
        <a-form class="form" :form="modal1.form" :colon="false">
          <a-form-item label="资料名称" required>
            <a-input
              v-decorator="[
                'documentName',
                {
                  rules: [{ required: true, message: '资料名称不能为空' }],
                },
              ]"
              placeholder="请输入资料名称"
            ></a-input>
          </a-form-item>
          <a-form-item label="图片示例">
            <PictureCardUpload
              v-decorator="['exampleUrl']"
              preview
              :itemWidth="150"
              :itemHeight="187"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料模版">
            <PictureCardUpload
              v-decorator="['templateUrl']"
              preview
              :tips="'点击上传'"
              :beforeUpload="beforeUpload"
              :itemWidth="198"
              :itemHeight="124"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料描述" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['documentDescription', { rules: [{ required: true, message: '请输入资料描述' }] }]"
            ></RichText>
          </a-form-item>
        </a-form>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="handleCancel" :disabled="formDcb">关闭</a-button>
        <a-button type="primary" @click="handleOk1" :disabled="formDcb">保存</a-button>
      </template>
    </a-modal> -->
    <!-- <a-modal title="修改排序" v-model="sortVisibleType" @ok="sortHandleOk" @cancel="handleCancelSort" :width="800">
      <draggable v-model="documentList" chosenClass="chosen" forceFallback="true" group="people" animation="800">
        <transition-group>
          <div class="item" v-for="(item, index) in documentList" :key="index + 'material'">
            <div style="border-right: 1px solid #dffdfdf; width: 120px; text-align: center">{{ index + 1 }}</div>
            <div>
              {{ item.documentName }}
            </div>
          </div>
        </transition-group>
      </draggable>
    </a-modal> -->
    <!-- <MaterialTemplate ref="materialTemplate"></MaterialTemplate> -->
    <!-- <CopyProductInfo ref="copyProductInfo"></CopyProductInfo> -->
  </div>
</template>

<script>
import RichText from '@/components/RichText'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import draggable from 'vuedraggable'
// import MaterialTemplate from './MaterialTemplate1.vue'
// import CopyProductInfo from './CopyProductInfo.vue'
export default {
  components: {
    PictureCardUpload,
    draggable,
    // MaterialTemplate,
    // CopyProductInfo,
    RichText,
  },
  props: {
    productId: {
      type: String,
      default: '',
    },
    visaType: {
      type: Number,
      default: null,
    },
    associationIdList: {
      type: Array,
    },
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      formDcb: false,
      sortVisibleType: false,
      oldList: [],
      addModalType: false,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '添加身份类型',
        data: {},
      },
      modal1: {
        edit: null,
        visible: false,
        form: this.$form.createForm(this),
        title: '添加新资料',
        data: {},
      },
      productTypeList: [],
      documentList: [],
      newObj: {
        documentId: null,
        productId: null,
        occupationId: null,
        documentName: '',
        countryName: '',
        documentType: 2,
        exampleUrl: '',
        templateUrl: '',
        documentDescription: '',
        type: 2,
        required: false,
        isNeed: 1,
      },
      countryList: [],
      documentId: '',
      editModalData: {},
      editIndex: null,
    }
  },
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    selectIsNeed(item, c, index) {
      c.type = item.type
      c.documentDescription = item.documentDescription
      c.templateUrl = item.templateUrl
      c.exampleUrl = item.exampleUrl
      c.documentType = item.documentType
      c.documentName = item.documentName
      c.countryName = item.countryName
      c.occupationId = this.productTypeList[index].occupationId
      c.productId = item.productId
    },
    updateVisaType(n) {
      if (this.documentList && this.documentList.length > 0) {
        if (n) {
          this.documentList.forEach(element => {
            if (element.children) {
              element.children.forEach(e => {
                e.documentType = n
              })
            }
          })
        }
      }
    },
    // async copyModal() {
    //   const id = await this.$refs.copyProductInfo.start()
    //   this.copyInit(id)
    // },

    updateMaterialType(e, item) {
      if (e === 1) {
      }
    },
    handleCancelSort() {
      if (this.oldList && this.oldList.length > 0) {
        this.documentList = JSON.parse(JSON.stringify(this.oldList))
      }
      this.sortVisibleType = false
    },
    sortHandleOk() {
      this.sortVisibleType = false
    },
    updateSort() {
      if (this.documentList && this.documentList.length) {
        this.oldList = JSON.parse(JSON.stringify(this.documentList))
        this.sortVisibleType = true
      } else {
        this.$message.error('暂无数据！')
      }
    },
    sysHandleScroll() {
      this.$refs.externalForm.scrollLeft = this.$refs.systemForm.scrollLeft
    },
    exterHandleScroll() {
      this.$refs.systemForm.scrollLeft = this.$refs.externalForm.scrollLeft
      this.$refs.externalForm1.scrollTop = this.$refs.externalForm.scrollTop
    },
    synchronousScroll() {
      this.$refs.externalForm.scrollTop = this.$refs.externalForm1.scrollTop
    },
    handleCancel() {
      this.modal.visible = false
      this.modal1.visible = false
      this.sortVisibleType = false
      this.modal1.edit = null
      this.formDcb = false
    },
    editData(item, index) {
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.modal1.form, { ...item })
      })
      this.modal1.edit = index
      this.modal1.visible = true
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          let editParams = {}
          if (this.modal.title === '修改身份类型') {
            editParams = this.editModalData
          } else {
            if (this.productTypeList.some(v => v.occupationName === params.occupationName)) {
              return this.$message.error('名称不可重复添加！')
            }
          }
          try {
            const res = await this.$axios.post('/visa/ /productMaterial/saveMaterialType', {
              data: {
                productId: this.productId,
                ...editParams,
                ...params,
              },
            })
            if (res.success) {
              if (this.modal.title !== '修改身份类型') {
                this.$emit('addtype', {
                  productId: this.productId,
                  occupationId: res.data,
                  params,
                })
                this.productTypeList.push({
                  productId: this.productId,
                  occupationId: res.data,
                  ...params,
                })
                this.documentList.forEach(element => {
                  const obj = JSON.parse(JSON.stringify(this.newObj))
                  obj.productId = this.productId
                  obj.occupationId = res.data
                  obj.type = 2
                  obj.documentName = element.documentName
                  obj.documentDescription = element.documentDescription
                  obj.exampleUrl = element.exampleUrl
                  obj.templateUrl = element.templateUrl
                  element.children.push(obj)
                })
              } else {
                this.$emit('updatetype', {
                  index: this.editIndex,
                  data: {
                    occupationId: editParams.occupationId,
                    occupationName: params.occupationName,
                    documentSort: params.documentSort,
                  },
                })
                this.productTypeList.splice(this.editIndex, 1, {
                  occupationId: editParams.occupationId,
                  occupationName: params.occupationName,
                  documentSort: params.documentSort,
                })
              }
            }
            this.$message.success('操作成功!')
            this.modal.visible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    removeData(index) {
      this.documentList.splice(index, 1)
    },
    async addFromModal() {
      const rows = await this.$refs.materialTemplate.start({ productType: 1 })
      rows.forEach(e => {
        const obj = {
          isNeed: 1,
          documentId: null,
          productId: this.productId ? this.productId : '',
          occupationId: null,
          type: 2,
          documentName: e.materialTemplateName,
          countryName: '',
          documentType: e.documentType,
          exampleUrl: e && e.exampleUrl ? e.exampleUrl : '',
          templateUrl: e && e.templateUrl ? e.templateUrl : '',
          documentDescription: e.documentDescription,
          required: e.required,
          children: [],
        }
        this.productTypeList.forEach(element => {
          const typeObj = JSON.parse(JSON.stringify(this.newObj))
          typeObj.occupationId = element.occupationId
          typeObj.productId = this.productId
          typeObj.documentName = e.materialTemplateName
          typeObj.type = 2
          typeObj.exampleUrl = e && e.exampleUrl ? e.exampleUrl : ''
          typeObj.templateUrl = e && e.templateUrl ? e.templateUrl : ''
          typeObj.documentDescription = e && e.documentDescription ? e.documentDescription : ''
          typeObj.documentType = e.documentType
          typeObj.exampleUrl = e && e.exampleUrl ? e.exampleUrl : ''
          typeObj.templateUrl = e && e.templateUrl ? e.templateUrl : ''
          typeObj.required = e.required
          obj.children.push(typeObj)
        })
        this.documentList.push(obj)
      })
    },
    handleOk1() {
      this.modal1.form.validateFields((errors, values) => {
        if (!errors) {
          const params = values
          if (this.modal1.edit === null) {
            if (this.productTypeList.some(v => v.occupationName === params.documentName)) {
              return this.$message.error('名称不可重复添加！')
            }
            const obj = {
              isNeed: 1,
              documentId: null,
              productId: this.productId ? this.productId : '',
              occupationId: null,
              documentName: params.documentName,
              countryName: '',
              documentType: 2,
              type: 2,
              exampleUrl: params && params.exampleUrl ? params.exampleUrl : '',
              templateUrl: params && params.templateUrl ? params.templateUrl : '',
              documentDescription: params.documentDescription,
              required: false,
              children: [],
            }
            this.productTypeList.forEach(e => {
              const typeObj = JSON.parse(JSON.stringify(this.newObj))
              typeObj.occupationId = e.occupationId
              typeObj.productId = this.productId
              typeObj.documentName = params.documentName
              typeObj.exampleUrl = params && params.exampleUrl ? params.exampleUrl : ''
              typeObj.templateUrl = params && params.templateUrl ? params.templateUrl : ''
              typeObj.documentDescription = params && params.documentDescription ? params.documentDescription : ''
              obj.children.push(typeObj)
            })
            this.documentList.push(obj)
          } else {
            this.documentList[this.modal1.edit].documentDescription = params.documentDescription
            this.documentList[this.modal1.edit].exampleUrl =
              params && params.exampleUrl ? params.exampleUrl : ''
            this.documentList[this.modal1.edit].templateUrl =
              params && params.templateUrl ? params.templateUrl : ''
            this.documentList[this.modal1.edit].documentName = params.documentName
            this.documentList[this.modal1.edit].children.forEach(e => {
              e.documentDescription = params.documentDescription
              e.exampleUrl = params && params.exampleUrl ? params.exampleUrl : ''
              e.templateUrl = params && params.templateUrl ? params.templateUrl : ''
              e.documentName = params.documentName
            })
          }
          this.modal1.visible = false
          this.formDcb = false
        }
      })
    },
    removeType(index, occupationId) {
      this.$axios
        .post('/visa/admin/productMaterial/deleteByMaterialTypeId', {
          data: {
            occupationId: occupationId,
          },
        })
        .then(res => {
          if (res.success) {
            this.$emit('removetypeto', index)
            this.documentList.forEach(e => {
              e.children.splice(index, 1)
            })
            this.productTypeList.splice(index, 1)
          }
        })
    },
    editType(index, record) {
      this.editIndex = index
      this.modal.visible = true
      this.modal.title = '修改身份类型'
      this.$nextTick(() => {
        this.modal.form.setFieldsValue({
          occupationName: record.occupationName,
          documentSort: record.documentSort,
        })
        this.editModalData = record
      })
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterial/deleteByMaterialTypeId', {
        data: {
          occupationId: row.occupationId,
        },
      })
      this.$message.success('操作成功!')
    },

    // async copyInit(productId) {
    //   if (productId) {
    //     // Material 根据产品Id查询身份类型列表
    //     const resData = await this.$axios.post(`/visa/admin/product/${productId}/occupation`)
    //     if (resData.data) {
    //       let count = 0
    //       const list = {}
    //       // 遍历身份类型 同步到赴官资料
    //       resData.data.forEach(async e => {
    //         // 保存身份类型(新增/修改)
    //         const res = await this.$axios.post('/visa/admin/productMaterial/saveMaterialType', {
    //           data: {
    //             ...e,
    //             productId: this.productId,
    //             occupationId: null,
    //           },
    //         })
    //         if (res.success) {
    //           count++
    //           list[e.occupationId] = res.data
    //           if (count === resData.data.length) {
    //             console.log('资料看完了,生成资料')
    //             // 生成新的资料数据
    //             this.assemblyDaata(productId, list)
    //           }
    //         }
    //       })
    //     }
    //   }
    // },

    // async assemblyDaata(productId, obj) {
    //   console.log('生成资料传递参数, productId', productId)
    //   console.log('生成资料传递参数, list', obj)
    //   // 根据产品Id查询  身份类型  列表
    //   const resData = await this.$axios.post('/visa/admin/productMaterial/queryByProductId', {
    //     data: {
    //       productId: this.productId,
    //     },
    //   })
    //   // 产品Id查询  资料信息  列表
    //   const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
    //     data: {
    //       productId,
    //     },
    //   })
    //   const resList = res.data.map(v => {
    //     return {
    //       ...v,
    //       productId: this.productId,
    //       occupationId: obj[v.occupationId],
    //     }
    //   })
    //   if (res.success) {
    //     const obj = {}
    //     const list = resList.filter(v => parseInt(v.type) === 2)
    //     const resToData = JSON.parse(JSON.stringify(list))
    //     const peon = list.reduce((cur, next) => {
    //       if (!obj[next.documentName]) {
    //         obj[next.documentName] = true && cur.push(next)
    //       }
    //       return cur
    //     }, [])

    //     if (resData.data && resData.data.length > 0) {
    //       peon.forEach(element => {
    //         element['children'] = []
    //         resData.data.forEach(async e => {
    //           element.occupationId = e.occupationId
    //           const obj = JSON.parse(JSON.stringify(this.newObj))
    //           obj.productId = this.productId
    //           obj.occupationId = e.occupationId
    //           obj.type = 2
    //           obj.documentName = element.documentName
    //           obj.exampleUrl = element && element.exampleUrl ? element.exampleUrl : ''
    //           obj.templateUrl = element && element.templateUrl ? element.templateUrl : ''
    //           obj.documentDescription = element && element.documentDescription ? element.documentDescription : ''
    //           element.children.push(obj)
    //         })
    //       })
    //     }
    //     this.documentList = JSON.parse(JSON.stringify(peon))
    //     this.productTypeList = resData.data
    //     this.productTypeList.forEach((ptype, index) => {
    //       this.documentList.forEach(e => {
    //         let obj = null
    //         if (e.children) {
    //           e.children.forEach(l => {
    //             obj = resToData.find(
    //               v => v.occupationId === ptype.occupationId && e.documentName === v.documentName
    //             )
    //           })
    //         }

    //         if (obj) {
    //           e.children[index] = Object.assign(e.children[index], obj)
    //           e.children[index]['isNeed'] = 1
    //         }
    //       })
    //     })
    //     this.documentList.forEach(e => {
    //       if (e.children) {
    //         e.children.forEach(e => {
    //           if (!e.documentId) {
    //             e.isNeed = 0
    //           }
    //         })
    //       }
    //     })
    //     this.documentList = JSON.parse(JSON.stringify(this.documentList))
    //   }
    //   this.$emit('arriveinit')
    // },

    updateProductId(list) {
      list.forEach(element => {
        if (element.children) {
          element.productId = this.productId
          this.updateProductId(element.children)
        }
      })
    },
    async init() {
      if (this.productId) {
        const resData = await this.$axios.get(`/visa/admin/product/${this.productId}/occupation`)
        const res = await this.$axios.get(`/visa/admin/product/${this.productId}/document`)

        if (res.success) {
          const obj = {}
          const list = JSON.parse(JSON.stringify(res.data.filter(v => parseInt(v.type) === 2)))
          const resToData = JSON.parse(JSON.stringify(res.data.filter(v => parseInt(v.type) === 2)))
          const peon = list.reduce((cur, next) => {
            if (!obj[next.documentName]) {
              obj[next.documentName] = true && cur.push(next)
            }
            return cur
          }, [])
          if (resData.data && resData.data.length > 0) {
            peon.forEach(element => {
              const zlist = resData.data.map(m => {
                const objs = resToData.find(
                  f => m.occupationId === f.occupationId && element.documentName === f.documentName
                )
                const obj1 = JSON.parse(JSON.stringify(this.newObj))
                obj1.isNeed = 0
                if (objs) {
                  objs.isNeed = 1
                }
                return objs || obj1
              })
              element.children = zlist
            })
          }
          this.documentList = peon
          this.productTypeList = resData.data
        }
      }
    },
    async addData() {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = '添加身份类型'
    },
    getList() {
      const list = []
      let index = 1
      this.documentList.forEach(e => {
        if (e.children) {
          e.children.forEach(l => {
            if (l.isNeed) {
              l.materialSort = index
              l.productId = this.productId
              list.push(l)
            }
            index++
          })
        }
      })
      return list
    },
    async add() {
      this.modal1.form.resetFields()
      this.modal1.edit = null
      this.modal1.visible = true
    },

    saveAsModel() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.resetModal$t()
          this.modal.visible = true
        }
      })
    },
    beforeUpload(file) {
      if (!file.name.toLowerCase().match(/\.(doc|docx|pdf|xls|xlsx|jpg|png|bmp)$/)) {
        this.$message.error('请上传doc、docx、xls、xlsx、pdf文件或jpg、png、bmp图片')
        return false
      }
    },
  },
}
</script>
<style lang="less">
.leftClass {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 20;
  overflow: hidden;
}
.l-input {
  .ant-select-selection--single {
    width: 100%;
  }
  .ant-select-selection__placeholder {
    display: auto !important;
  }
}
</style>
<style lang="less" scoped>
.m-tt::-webkit-scrollbar {
  display: none;
}
.sort-list {
  border: 1px solid #dfdfdf;
  padding: 10px 0;
  margin-bottom: 10px;
  border-radius: 10px;
}
.t-content {
  // margin-top: 30px;

  .p-m-table {
    border: 1px solid #dfdfdf;
    margin-bottom: 30px;
    width: 100%;
    .hadder {
      overflow-y: auto;
      display: flex;
      background: #fd7163;
      position: relative;
      padding-right: 10px;
      .h-t {
        flex-shrink: 0;
        background: #fd7163;
        color: #fff;
        line-height: 50px;
        text-align: center;
      }
    }
    .hadder::-webkit-scrollbar {
      display: none;
    }
    .p-m-title {
      top: 50px;
      bottom: 0;
      width: 100%;
      min-height: 100px;
      max-height: 500px;
      overflow: auto;
      // overflow-y: hidden;
      .hadder {
        display: flex;
        background: #fd7163;
        .h-t {
          flex-shrink: 0;
          height: 50px;
          background: #fd7163;
          color: #fff;
          line-height: 50px;
          text-align: center;
        }
      }
      .content {
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        .h-c {
          flex-shrink: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .h-c-d {
            flex-shrink: 0;
            border: 1px solid #dfdfdf;
            height: 126px;
            min-height: 126px;
            max-height: 126px;
            display: flex;
            justify-content: center;
            align-items: center;
            .h-c-item {
              height: 20%;
              line-height: 40px;
              text-align: center;
              border-bottom: 1px solid #dfdfdf;
              width: 100%;
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
        .h-c-1 {
          flex: 1;
          display: flex;
          height: 126px;
          min-height: 126px;
          max-height: 126px;
          .h-c-1-s {
            flex-shrink: 0;
            width: 200px;
            display: flex;
            flex-direction: column;
            div {
              flex-shrink: 0;
              height: 42px;
              display: flex;
              .l-title {
                flex-shrink: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #dfdfdf;
                width: 120px;
              }
              .l-input {
                flex-shrink: 0;
                flex: 1;
                border: 1px solid #dfdfdf;
                text-align: center;
                padding: 4px 20px 0 20px;
              }
            }
          }
        }
      }
    }
    // .p-m-title::-webkit-scrollbar {
    //   display: none;
    // }
  }
}
/*被拖拽对象的样式*/
.item {
  display: -webkit-box;
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  cursor: move;
}
/*选中样式*/
.chosen {
  border: solid 1px #3089dc !important;
}
</style>
